<template lang="pug">
  .product-carousel
    SimpleCarouselSSR(v-if="products.length > 0" ref="slick" :options="options")
      ProductCard(v-for="prodObj in products" :prod-obj="prodObj" :key="prodObj.id" :overrides="overridesMap[prodObj.id]" :set-width="true" :track-event-name="trackEventName")

</template>

<script>
  import vueProductSvc from "@services/vueProductSvc";
  import SimpleCarouselSSR from "@components/SimpleCarouselSSR/SimpleCarouselSSR.vue";
  import ProductCard from "@components/ProductCard/ProductCard.vue";

  export default {
    name: "ProductCarousel",
    components: {ProductCard, SimpleCarouselSSR},

    data() {
      return {
        products: [],
      };
    },

    props: {
      options: {
        type: Object,
        default: () => ({}),
      },

      ctaSource: {
        type: String,
        default: "",
      },

      productIds: {
        type: Array,
        default: () => [],
      },

      trackEventName: {
        type: String,
        default: "Product Carousel",
      },

      overridesMap: {
        type: Object,
        default: () => ({}),
      },
    },

    created() {
      if (this.productIds) {
        vueProductSvc.getProductsById({ ids: this.productIds }).then(res => {
          this.products = res.data;
        });
      }
    }
  };
</script>

<style scoped lang="stylus">

</style>